/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react"
import { ListGroup, Card } from "react-bootstrap"
import "../BodyContent.scss"
// import Board from "../../comments/Comments"
import {
	getVideosByUser,
	getUserByToken,
	deleteVideo,
	editVideo,
} from "../../services/Api"
import { handleUserSetup } from "../../redux/actions/User"
import { connect } from "react-redux"
import { MongoTimeConvert } from "../../converters/timeConverters"
import VideoUserSideBar from "./userVideoSideBar"
import EditModal from "../../modals/EditModal"
// import VideosFeed from "../feed/videos"
import VideoComments from "../../comments/VideoComments"
import { toast } from "react-toastify"
import QuestionsFeed from '../feed/questions';
import MainLoader from "../loader/MainLoader"
const EDUCATE_TOKEN = "educate_token"

class UsersVideos extends Component {
	
	state = {
		diplay: "none",
		data: [],
		editmodal: false,
		allVideos: [],
		id: "",
		videoName: "",
		loading: true
	}

	handleEdit = async () => {
		const form = this.formRef.current
		form.validateFields().then(async (values) => {
			const user = {
				videoId: this.state.id,
				videoName: values.inputname,
			}
			console.log(user)
			const editedQuiz = await editVideo(user)
			toast(editedQuiz.message)
			this.setState({
				...this.state,
				editmodal: false,
			})
			this.componentDidMount()
		})
	}

	deleteVideo = async (id) => {
		const quizid = {
			id: id,
		}
		const deletedVideo = await deleteVideo(quizid)
		toast(deletedVideo.message)
		this.componentDidMount()
	}
	
	_onKeyUp = (e) => {
		const data = this.state.allVideos.filter((item) =>
			item.videoDescription
				.toLowerCase()
				.includes(e.target.value.toLowerCase())
		)
		this.setState({
			...this.state,
			data 
		})
	}

	loadNewQuestions = (params) => {
		console.log(params)
		this.setState({
			...this.state,
			data: params,
			allVideos: params,
		})
	}
	

	showEditModal(id, video) {
		this.setState({
			...this.state,
			editmodal: true,
			videoName: video,
			id: id,
		})
	}

	hideEditModal() {
		this.setState({
			...this.state,
			editmodal: false,
		})
	}

	displayComments(displayComments, id) {
		var newDisplay = ""
		const allVideos = this.state.data
		for (var i = 0; i < allVideos.length; i++) {
			if (allVideos[i]._id === id) {
				if (allVideos[i].displayComments === "block") {
					newDisplay = "none"
				} else {
					newDisplay = "block"
				}
				allVideos[i].displayComments = newDisplay
			}
		}
		this.setState({
			...this.state,
			data: allVideos,
		})
	}

	async checkLogedIn() {
		if (localStorage.getItem(EDUCATE_TOKEN)) {
			const user = await getUserByToken()
			console.log(user)
			this.props.dispatch(handleUserSetup(user.user))
		} else {
			console.log("User not logged in")
		}
	}

	async componentDidMount() {
		await this.checkLogedIn()
		const userid = {
			id: this.props.currentUser._id,
		}

		console.log(userid)
		const Videos = await getVideosByUser(userid)
		
		this.setState({
			...this.state,
			data: Videos,
			allVideos: Videos,
			loading: false
		})
	}

	formRef = React.createRef()

	render() {
		return (
			<React.Fragment>
				<MainLoader loading={this.state.loading} />
				<div className='contentDiv'>
					<div className='col-lg-2' id="sidebarContent">
						<VideoUserSideBar
							LoadQuestion={this.loadNewQuestions}
						/>
					</div>
					<div className='col-lg-6'>
						<div className='middleSection'>
							<div className='generalQuestion'>Your Content</div>
						</div>
						{ this.state.data != null && this.state.data.map((item) => (
							<div className='questionsCard'>
								<Card>
									<Card.Body>
										<Card.Header>
											<div className='headerStructure'>
												<div className='userNameAndIcon'>
													<div className='imageIcon'>
														<img alt='User Icon'
															src={require("../../icons/iconuser.png")}
														/>
													</div>
													<div className='ownerName'>
														{item.user.fullName}
														<span>
															{" "}
															{MongoTimeConvert(
																item
																	.createdAt
															)}
														</span>{" "}
													</div>
												</div>
												<div className='editCancelIcons'>
													<div>
														<img alt='User Icon'
															onClick={() =>
																this.showEditModal(
																	item._id,
																	item.videoDescription
																)
															}
															className='cardCloseIcon'
															src={require("../../icons/edit-outlined.svg")}
														/>
													</div>
													<div>
														<img alt='User Icon'
															className='cardCloseIcon'
															onClick={() =>
																this.deleteVideo(
																	item._id
																)
															}
															src={require("../../icons/close-outlined.svg")}
														/>
													</div>
												</div>
											</div>
										</Card.Header>
										<Card.Text>
											{item.videoDescription}
										</Card.Text>
									</Card.Body>
									<video
										controls
										className='userVideos'
										src={item.videoLink}
									/>
									<div>
										<div className='commentIcon'>
											<div
												onClick={() =>
													this.displayComments(
														item.displayComments,
														item._id
													)
												}
												className='imageIcon'
											>
												<img alt='User Icon'
													className='cardIcon'
													src={require("../../icons/comment-outlined.svg")}
												/>
												<span>
													{item.comments.length}
												</span>
											</div>
										</div>
									</div>
									<div>
										<div
											style={{
												display: item.displayComments,
											}}
										>
											<VideoComments
												userComment={item.comments}
												video={item._id}
												addComments={this.addComments}
											/>
										</div>
									</div>
								</Card>
							</div>
						))}
					</div>
					<div className='col-lg-2' id='improve-your-feed'>
						<div className='middleSection'>
							<ListGroup>
								<ListGroup.Item className='listFirstItem feedCateGoryName'>
									Improve Your feed
								</ListGroup.Item>
								<QuestionsFeed />
							</ListGroup>
						</div>
					</div>
				</div>
				<EditModal
					name={this.state.videoName}
					questionid={this.state.id}
					formRef={this.formRef}
					onSignUpClick={() => this.showEditModal()}
					visible={this.state.editmodal}
					onCancel={() => this.hideEditModal()}
					onCreate={this.handleEdit}
				/>
			</React.Fragment>
		)
	}
}

function mapStateToProps({ currentUser }) {
	return {
		currentUser: currentUser,
	}
}

export default connect(mapStateToProps)(UsersVideos)
